import _ from "lodash"
import { getApiFeedData, parseContent, parseSingleContent } from "../renderers/utils"


export default function useDataCollector(){

  const testData = null
  // const testData = {
  //   "rp.RepresentmentTransactionInfo.Wallet": "PayPal"
  // }

  const getActionsForLocation = (location:string, renderPkg:any) => {
    const { subdomain, rpid } = renderPkg;
    let result:any[] = []
    let compareValue:any;

    let matchingActions:any[] = [] 
    renderPkg.rulesdata.filter( (rule:any) =>
      rule.location === location && 
      (rule.subdomain === "-any-" || rule.subdomain === subdomain) &&
      (rule.rpid === "-any-" || rule.rpid === rpid)
    ).forEach( (ruleObj:any) => {
      // console.log("checking ruleObj", ruleObj)
      ruleObj.conditions.forEach( (condition:any) => {
        let verdict = false
        if( condition.lookup ){
          compareValue = (process.env.NODE_ENV === "development" && testData && testData[condition.lookup]) 
            ? testData[condition.lookup] 
            : _.get(renderPkg, condition.lookup, null); 

          switch( condition.operator){
            case "eq":
              verdict = (compareValue === condition.value);
              break;
            case "neq":
              verdict = (compareValue !== condition.value);
              break;
            case "contains":
              verdict = (compareValue && compareValue.includes(condition.value));
              break;
            case "notcontains":
              verdict = (compareValue && !compareValue.includes(condition.value));
              break;
            case "exists":
              verdict = (compareValue !== null && compareValue !== undefined);
              break;
            case "notexists":
              verdict = (compareValue === null || compareValue === undefined);
              break;
            default:
              console.warn("Unknown operator in condition", condition.operator)
          }
         
          if( verdict ){
            matchingActions = [...matchingActions, ...condition.actions]
          }
        }
      })
    })
    // console.log("matchingActions", matchingActions)
    return matchingActions
  }

  const getKeyFromPath = (path: string) => {
    const parts = path.split(".");
    return parts[parts.length - 1];
  };

  const getParsedContent = (item:any, renderPkg:any, idx:number = 0) => {
    const parsed = parseSingleContent({ 
      path: item.path, 
      clientDataObj: renderPkg.clientdata, 
      apiData: renderPkg.apidata,
      idx: idx,
    })
    return { label: item.label, value: parsed, refstr: item.refstr }
  }

  const extractFromObject = (dataObj: Record<string, any>, structure: any[]) => {
    const result: Record<string, any> = {};
    structure.forEach((field) => {
      const lookupKey = field.path // getKeyFromPath(field.path);
      result[field.refstr] = {
        label: field.label,
        refstr: field.refstr,
        path: field.path,
        value: _.get(dataObj, lookupKey, null)
      };
    });
    return result;
  };

  const extractFromArray = (dataArray: any[], structure: any[]) => dataArray.map((item, idx) => {
    const details = item.TransactionDetails || {}; // Defensive fallback
    return structure.map((field) => {
      const key = getKeyFromPath(field.path);
      return { label: field.label, refstr: field.refstr, path: field.path, value: _.get(details, key, null) };
    });
  });

  const applyRulesToDataArr = (dataArr:any[], actions:any[], renderPkg:any) => {
    const newDataArr = dataArr.map((dataObj:any) => {
      const actionMatch = actions.find( (action:any) => action.target === dataObj.refstr )
      if( !actionMatch ){
        return { ...dataObj, value: getParsedContent(dataObj, renderPkg).value };
      } else {
        if( actionMatch.action === "hide" ) {
          return { ...dataObj, okToRender: false };
        } else if( actionMatch.action === "replace" ){
          const newDataObj = {
            path: actionMatch.replaceData || dataObj.path,
            label: actionMatch.replaceLabel || dataObj.label
          };
          return { ...newDataObj, value: getParsedContent(newDataObj, renderPkg).value, okToRender: true };
        }
      }
    })
    return newDataArr;
  }

  const applyRulesToDataObj = (dataObj:any, actions:any[], renderPkg:any, idx:number = 0) => {
    const newDataObj = Object.keys(dataObj).reduce((acc, key) => {
      const actionMatch = actions.find( (action:any) => action.target === dataObj[key].refstr );
      if( !actionMatch ){
        acc[key] = { ...dataObj[key], value: getParsedContent(dataObj[key], renderPkg, idx).value };
      } else {
        if( actionMatch.action === "hide" ) {
          acc[key] = { ...dataObj[key], okToRender: false };
        } else if( actionMatch.action === "replace" ){
          const newDataObj = {
            path: actionMatch.replaceData || dataObj[key].path,
            label: actionMatch.replaceLabel || dataObj[key].label
          };
          acc[key] = { ...newDataObj, value: getParsedContent(newDataObj, renderPkg, idx).value, okToRender: true };
        }
      }
      return acc;
    }, {});
    console.log("applyRulesToDataObj result", newDataObj)
    return newDataObj;
  }


  const prepDataForRender = (location:string, data:any, structure: any[], renderPkg: any[], datashape:string="object", idx:number = 0) => {
    if( datashape === "object" ){
      const basedata = extractFromObject(data, structure);
      const actions = getActionsForLocation(location, renderPkg);
      const result = applyRulesToDataObj(basedata, actions, renderPkg, idx);
      return result
    }
    else if( datashape === "array" ){
      const baseDataArr = extractFromArray(data, structure);
      const actions = getActionsForLocation(location, renderPkg);
      const result = applyRulesToDataArr(baseDataArr, actions, renderPkg);
    } else {
      console.warn("Unknown datashape", datashape)
      return [];
    }
  }


  return {
    extractFromObject,
    extractFromArray,
    getActionsForLocation,
    prepDataForRender
  }
}